import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ContainerSize from "../container";
import {
  EmailIcon,
  FaceBookIcon,
  InstagramIcon,
  LinkedInIcon,
  PhoneIcon,
  TwitterIcon,
  Youtube,
} from "../Icons";
import OptimizedImage from "../imageOptimise";


const NavBar = ({ image, bgColor, title, description, childrenContainer }) => {
  const [showStickyNav, setShowStickyNav] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);

  const location = useLocation();
  const currentPath = location.pathname;

  const toggleSubMenu = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const navBarData = [
    { name: "HOME", path: "/" },
    {
      name: "SERVICES",
      path: "/services",
      subItems: [
        { name: "New Business", image: "/images/servicesImages/new_business.png", path: "/services/new-business-services" },
        { name: "Policy Management", image: "/images/servicesImages/policy.png", path: "/services/policy-management-services" },
        { name: "Insurance Accounting", image: "/images/servicesImages/accounting.png", path: "/services/insurance-accounting-services" },
        { name: "Insurance Reporting", image: "/images/servicesImages/reporting.png", path: "/services/insurance-reporting-services" },
        { name: "Commission Management", image: "/images/servicesImages/commission.png", path: "/services/commission-management-services" },
        { name: "Claims Management", image: "/images/servicesImages/claim.png", path: "/services/claims-management-services" },
        { name: "Claims Data Entry", image: "/images/servicesImages/data_entry.png", path: "/services/claims-data-entry-services" },
        { name: "Web Application Service", image: "/images/servicesImages/websitedesign.jpg", path: "/services/web-application-services" },
        { name: "Digital Marketing Service", image: "/images/servicesImages/DigitalMarketing.jpg", path: "/services/digital-marketing-services" },
        { name: "IMASH Technologies", image: "/images/servicesImages/imashservice.jpg", path: "https://www.imashtech.com/",  target:"_blank"}
      ],
    },
    { name: "ABOUT US", path: "/about-us" },
    {
      name: "RESOURCES", path: "/resources",
      subItems: [
        { name: "Blogs", image: "/images/Resources/blogs-image.jpg", path: "/resources/blogs" },
        { name: "Brochures", image: "/images/Resources/brochers-image.jpg", path: "/resources/brochures" },
        { name: "Videos", image: "/images/Resources/video-image.jpg", path: "/resources/videos" }
      ]
    },
    { name: "EVENTS", path: "/events" },
    { name: "CONTACT", path: "/contact" },
  ];


  useEffect(() => {
    const handleScroll = () => {
      setShowStickyNav(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [activeIndex, setActiveIndex] = useState(null);
  const [showNavSub, setShowNavSub] = useState(true);
  const [activeIndex1, setActiveIndex1] = useState(null);
  const [showNavSub1, setShowNavSub1] = useState(true);

  const handleMouseEnter = (index) => {
    if (showNavSub) {
      setActiveIndex(index);
    }
  };
  const handleSubItemClick = () => {
    setShowNavSub(false);
    setActiveIndex(null);
    setTimeout(() => {
      setShowNavSub(true);
    }, 200);
  };




  const handleMouseEnter1 = (index) => {
    if (showNavSub) {
      setActiveIndex1(index);
    }
  };
  const handleSubItemClick1 = () => {
    setShowNavSub1(false);
    setActiveIndex1(null);
    setTimeout(() => {
      setShowNavSub1(true);
    }, 200);
  };


  const renderNavLinks = () =>
    navBarData.map((item, index) => (
      <div
        key={index}
        className="relative"
        onMouseEnter={() => handleMouseEnter(index)}

      >
        <Link
          to={item.path}
          className={`font-semibold block py-2 transition duration-300 ${currentPath === item.path
            ? "text-blue-600"
            : "text-gray-800 hover:text-blue-500"
            }`}
        >
          {item.name}
        </Link>

        {/* Show submenu only if hovered */}
        {showNavSub && activeIndex === index && item.subItems && (
          <div onMouseLeave={handleSubItemClick}
            className="absolute left-[-300px] mt-3 bg-white border shadow-md rounded-md z-10 w-max max-w-[1150px]">
            <ul className="py-4 px-2 flex flex-wrap gap-4 w-auto">
              {item.subItems.map((subItem, subIndex) => (
                <li
                  key={subIndex}
                  className="hover:bg-gray-300 rounded-md transition p-2 w-[210px]"
                  onClick={handleSubItemClick}
               
                >
                  <div className="flex flex-col items-center">
                    <Link to={subItem.path} className="w-full" target={subItem.target ? subItem.target : undefined}>
                      <div className="relative group w-full h-full rounded-md overflow-hidden">
                        <OptimizedImage
                          src={subItem.image}
                          alt={subItem.name}
                          className="w-[250px] h-[150px] object-cover"
                        />
                        

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center
                        opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 
                        transition-all duration-500 ease-in-out"
                        >
                          <h3 className="text-white text-lg font-bold px-2 text-center">
                            {subItem.name.toUpperCase()}
                          </h3>
                        </div>
                      </div>
                    </Link>

                    <p className="text-gray-800 font-medium text-center mt-2">
                      {subItem.name}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    ));


  return (
    <>

      <div className="relative">
        {image ? (
          <OptimizedImage
            src={image}
            alt="Banner"
            className="w-full h-[700px] sm:w-[300px] md:w-[500px] lg:w-full md:w-[300px] sm:h-[600px] md:h-[600px] lg:h-[700px] xl:h-[780px] object-cover"
          />
        ) : (
          <div className={`w-full h-[950px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[780px] ${bgColor || "bg-gray-300"}`}></div>
        )}

        {/* Text over banner */}
        <ContainerSize>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-start w-full px-4 md:px-10 lg:px-20">
            <div className="max-w-full max-w-[330px] bottom-[100px] top-[-100px] md:max-w-[800px] mx-auto absolute left-[25px] md:left-[200px]">
              <h1 className="text-white text-[28px]  leading-[36px] sm:text-[32px] sm:leading-[42px] md:text-[50px] md:leading-[60px] font-bold animate-slideDown">
                {title}
              </h1>
              <p className="mt-4 text-white font-normal text-[16px] leading-[24px] md:text-[18px] md:leading-[27px] animate-slideDown">
                {description}
              </p>
              {currentPath === "/" && (
                <div className="pt-6">
                  <Link to="/about-us">
                    <button className="bg-[#f18801] hover:bg-[#1b4a78] hover:animate-pulse text-white font-semibold py-2 px-6 rounded-lg shadow-md transition duration-300">
                      VIEW MORE
                    </button>
                  </Link>
                </div>
              )}
            </div>
            {childrenContainer && <div className="w-full max-w-screen-xl mx-auto mt-[90px]">{childrenContainer}</div>}
          </div>
        </ContainerSize>

        {/* Absolute Top Navigation */}
        <header className="absolute top-0 left-0 w-full pt-4 z-20">
          <ContainerSize>
            <div className="flex justify-between items-center px-4 md:px-0">
              {/* Logo */}
              <Link to="/">
                <OptimizedImage
                  src="/images/imashLogo.png"
                  alt="Logo"
                  className="w-[140px] sm:w-[160px] md:w-[180px]"
                />
              </Link>

              {/* Desktop Nav + Free Trial Button */}
              <div className="hidden md:flex items-center gap-5">
                {/* Navigation */}
                <nav className="flex justify-center bg-gray-200/80 backdrop-blur-md shadow-md py-2 rounded-lg px-4 md:px-6 gap-4 md:gap-8 w-full max-w-[900px]">
                  {renderNavLinks()}
                </nav>
                <Link to={"/free-trial"}>
                  <div className="w-[200px]">

                    <button
                      className="bg-gradient-to-r from-orange-500 to-blue-500 
                 text-white font-extrabold px-6 py-2 rounded-full 
                 shadow-lg shadow-blue-500/50 
                 animate-pulse text-base md:text-lg tracking-wide"
                    >
                      Free Trial
                    </button>
                  </div></Link>


              </div>

              {/* Mobile Menu Button */}
              <button
                className="md:hidden text-white bg-[#1b4a78] px-4 py-2 rounded-md"
                onClick={() => setMobileMenuOpen(true)}
              >
                ☰
              </button>
            </div>

          </ContainerSize>
        </header>
      </div>

      {/* Sticky Nav */}
      <div className={`fixed top-0 left-0 w-full z-50 transition-transform duration-500 ${showStickyNav ? "translate-y-0" : "-translate-y-full"} bg-white shadow-md`}>
        <ContainerSize>
          <div className="flex justify-between items-center py-4">
            <Link to="/">
              <OptimizedImage src="/images/imashLogo.png" alt="Sticky Logo" className="w-[150px] h-[60px]" />
            </Link>

            <div className="hidden md:flex items-center gap-10 pl-10">

              <nav className="hidden md:flex gap-8">

                {
                  navBarData.map((item, index) => (
                    <div key={index} className="relative group"
                      onMouseEnter={() => handleMouseEnter1(index)}
                    >
                      <Link
                        to={item.path}
                        className={`font-semibold block py-2 transition duration-300 ${currentPath === item.path
                          ? "text-blue-600"
                          : "text-gray-800 hover:text-blue-500"
                          }`}
                      >
                        {item.name}
                      </Link>


                      {showNavSub1 && activeIndex1 === index && item.subItems && (
                        <div
                          onMouseLeave={handleSubItemClick1} className="absolute left-[-310px] top-[60px]  mt-3 bg-white border shadow-md rounded-md opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all duration-300 z-10 w-max max-w-[950px] ">
                          <ul className="py-4 px-2 flex flex-wrap gap-4 w-auto">
                            {item.subItems.map((subItem, subIndex) => (
                              <li
                                key={subIndex}
                                className="hover:bg-gray-300 rounded-md transition p-2 w-[210px]"
                                onClick={handleSubItemClick1}
                              >
                                <div className="flex flex-col items-center">
                                  <Link to={subItem.path}>
                                    {/* Each subItem has its own group */}
                                    <div className="relative group w-[200px] h-[150px] rounded-md overflow-hidden">
                                      <OptimizedImage
                                        src={subItem.image}
                                        alt={subItem.name}
                                        className="w-[200px] h-[150px] object-cover"
                                        loading="lazy"
                                      />

                                      {/* Overlay - only shows when this item is hovered */}
                                      <div
                                        className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center
          opacity-0 hover:opacity-100 translate-y-4 hover:translate-y-0
          transition-all duration-500 ease-in-out"
                                      >
                                        <h2 className="text-white text-lg font-bold px-2 text-center">
                                          {subItem.name.toUpperCase()}
                                        </h2>
                                      </div>
                                    </div>
                                  </Link>

                                  {/* Label under the image */}
                                  <p className="text-gray-800 font-medium text-center mt-2">
                                    {subItem.name}
                                  </p>
                                </div>
                              </li>

                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  ))

                }

              </nav>
              <Link to={"/free-trial"}>
                <div className="w-[150px]">

                  <button
                    className="bg-gradient-to-r from-orange-500 to-blue-500 
                 text-white font-extrabold px-6 py-2 rounded-full 
                 shadow-lg shadow-blue-500/50 
                 animate-pulse text-base md:text-lg tracking-wide"
                  >
                    Free Trial
                  </button>
                </div></Link>
            </div>

            <button
              className="md:hidden text-black bg-gray-200 px-3 py-2 rounded"
              onClick={() => setMobileMenuOpen(true)}
            >
              ☰
            </button>
          </div>
        </ContainerSize>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-white z-50 shadow-lg transform transition-transform duration-500 ${mobileMenuOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="flex justify-end p-4">
          <button
            className="text-black text-xl"
            onClick={() => {
              setMobileMenuOpen(false);
              setOpenIndex(null);
            }}
          >
            ✕
          </button>
        </div>
        <nav className="flex flex-col justify-between h-[700px] px-6 py-4">
          <div className="flex flex-col gap-4">
            {navBarData.map((item, index) => (
              <div key={index}>
                <div
                  onClick={() => {
                    if (item.subItems) {
                      toggleSubMenu(index);
                    } else {
                      setMobileMenuOpen(false);
                    }
                  }}
                  className="cursor-pointer text-gray-800 hover:text-blue-600 text-lg font-medium"
                  
                >
                  {item.subItems ? (
                    <span>{item.name}</span>
                  ) : (
                    <Link to={item.path}>{item.name}</Link>
                  )}
                </div>
                {item.subItems && openIndex === index && (
                  <ul className="ml-4 mt-2">
                    {item.subItems.map((subItem, subIndex) => (
                      <li key={subIndex}>
                        <Link
                          to={subItem.path}
                          onClick={() => setMobileMenuOpen(false)}
                          className="text-gray-600 hover:text-blue-500 text-md"
                        >
                          {subItem.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
            <Link to={"/free-trial"}>
              <div className="w-[200px] pt-5">

                <button
                  className="bg-gradient-to-r from-orange-500 to-blue-500 
                 text-white font-extrabold px-6 py-2 rounded-full 
                 shadow-lg shadow-blue-500/50 
                 animate-pulse text-base md:text-lg tracking-wide"
                >
                  Free Trial
                </button>
              </div></Link>
          </div>


          <div className="mt-6 mb-7 text-gray-800 font-semibold">
            <div className="flex items-center justify-center gap-2 pb-2">
              <EmailIcon />
              <p className="font-medium">shan@imashinsure.com</p>
            </div>
            <div className="flex gap-2">
              <PhoneIcon />
              <p className="font-medium">7658882158</p>
            </div>
            <div className="flex items-center justify-center gap-2 pb-2 pt-3">
              <FaceBookIcon />
              <InstagramIcon />
              <LinkedInIcon />
              <TwitterIcon />
              <Youtube />
            </div>
          </div>
        </nav>


      </div>


    </>
  );
};

export default NavBar;
